import { createApp } from "vue";
import vuetify from "./plugins/vuetify";
import App from "./app.vue";
import Store from "@/store";
import Router from "./router";
import Window from "@/components/window.vue";
import { ElDropdown, ElDropdownMenu, ElDropdownItem } from "element-plus";
import "element-plus/lib/theme-chalk/index.css";

// import { EventBusPlugin as eventBus } from "@/assets/event_bus";

import "./assets/common.scss";

const app = createApp(App);

app.component(ElDropdown.name, ElDropdown);
app.component(ElDropdownMenu.name, ElDropdownMenu);
app.component(ElDropdownItem.name, ElDropdownItem);

app.use(Router);
app.use(Store);
app.use(vuetify);

// app.use(eventBus);

app.component("window", Window);

Store.commit("setCache");

app.mount("#app");
